import { Component } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-incident-type-datasource-editor',
    templateUrl: './incident-type-datasource-editor.component.html',
    styleUrls: ['./incident-type-datasource-editor.component.scss', '../../layout/layout.component.scss']
})
export class IncidentTypeDataSourceEditor {
    dataSource: any[] = [];

    private _formGroup: FormGroup;

    constructor(public activeModal: NgbActiveModal) {
        this._formGroup = new FormGroup({
            values: new FormArray([])
        });
    }

    ngOnInit() {
        if (this.dataSource != null) {
            this.dataSource.forEach(ds => {
                this.valuesControl.push(new FormControl(ds));
            });
        }

        this.valuesControl.push(new FormControl(null));
    }

    get form() {
        return this._formGroup;
    }

    get valuesControl(): FormArray {
        return (this._formGroup.controls["values"] as FormArray);
    }

    hasValue(index) {
        return this.valuesControl.at(index).value;
    }

    changed(index) {
        if ((index + 1) === this.valuesControl.length) {
            this.valuesControl.push(new FormControl(null));
        }
    }

    remove(index) {
        this.valuesControl.removeAt(index);
    }

    saveChanges() {
        this.valuesControl.removeAt(this.valuesControl.length - 1);

        let result = this.valuesControl.controls.map(c => {
            return c.value;
        });

        this.activeModal.close(result);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/incident-types/incident-type-field-setting/incident-type-datasource-editor.component.ts